import React from "react";
import { Text, Flex, Box, type FlexProps } from "@chakra-ui/react";
import { type Integration } from "lib/sanity";
import Image from "next/image";
import { ArrowIcon } from "./arrow-icon";

type SyncRowProps = {
  source: Integration;
  destination: Integration;
  sourceText: string;
  destinationText: string;
};

export function SyncRow({ source, destination, sourceText, destinationText }: SyncRowProps) {
  return (
    <Flex w="100%" align="center">
      <FieldContainer>
        {source.iconUrl && <Logo url={source.iconUrl} name={source.name} />}

        <TextWrapper>{sourceText}</TextWrapper>
      </FieldContainer>

      <ArrowIcon flex={0.4} mr={{ base: 2, lg: 3 }} />

      <FieldContainer border="2px" borderColor="new.green.500">
        {destination.iconUrl && <Logo url={destination.iconUrl} name={destination.name} />}

        <TextWrapper color="new.green.900">{destinationText}</TextWrapper>
      </FieldContainer>
    </Flex>
  );
}

function FieldContainer({ borderColor = "new.gray.150", border = "1px", children }: FlexProps) {
  return (
    <Flex
      alignItems="center"
      alignSelf="stretch"
      gap={{ base: "tinier", md: "tiny" }}
      flex={1}
      p={{ base: "tiny", xl: "smallest" }}
      border={border}
      borderColor={borderColor}
      borderRadius="tiny"
      boxShadow="sm"
    >
      {children}
    </Flex>
  );
}

function Logo({ url, name }: { url: string; name: string }) {
  return (
    <Box pos="relative" boxSize={{ base: 6, md: 4, xl: 6 }} flexShrink={0}>
      <Image fill src={url + "?w=60"} alt={name + "."} sizes="100%" />
    </Box>
  );
}

function TextWrapper({ color, children }: FlexProps) {
  return (
    <Text color={color} fontWeight="semibold" textStyle={{ base: "caption2", lg: "caption1" }} fontSize="brand.2xs">
      {children}
    </Text>
  );
}
